import { render, staticRenderFns } from "./tags-input.vue?vue&type=template&id=d22ff668&scoped=true&"
import script from "./tags-input.vue?vue&type=script&lang=ts&"
export * from "./tags-input.vue?vue&type=script&lang=ts&"
import style0 from "./tags-input.vue?vue&type=style&index=0&id=d22ff668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22ff668",
  null
  
)

export default component.exports